// WP-12 Step I.1: personal-task severity — one source of truth shared by the
// Activities To-do tab and the Work Queue TASKS block so the two stay identical.
export const TASK_SEVERITIES = ['urgent', 'normal', 'low'];

// Display order (urgent first) + design-token colors.
export const SEVERITY_CFG = {
  urgent: { label: 'Urgent', rank: 0, color: 'var(--red)',    bg: 'var(--red-bg)' },
  normal: { label: 'Normal', rank: 1, color: 'var(--blue)',   bg: 'var(--blue-bg)' },
  low:    { label: 'Low',    rank: 2, color: 'var(--muted2)', bg: '#eef1ee' },
};

export const severityRank = (s) => SEVERITY_CFG[s]?.rank ?? 1;
export const severityLabel = (s) => SEVERITY_CFG[s]?.label ?? 'Normal';
